import { defineMessages } from 'react-intl';

export default defineMessages({
  landingHeading: {
    id: 'src.pages.Services.landingHeading',
    defaultMessage: 'Let’s get you on your way',
  },
  landingIntroCopy: {
    id: 'src.pages.Services.landingIntroCopy',
    defaultMessage: 'You’re eligible for an Enterprise rental or Uber voucher to help get you on your way.',
  },
  landingIntroEnterprise: {
    id: 'src.pages.Services.landingIntroEnterprise',
    defaultMessage: 'Enterprise Rental',
  },
  landingIntroEnterpriseDes: {
    id: 'src.pages.Services.landingIntroEnterpriseDes',
    defaultMessage: 'You’re covered for a rental that is similar in size and seating to your current vehicle.',
  },
  landingIntroUber: {
    id: 'src.pages.Services.landingIntroUber',
    defaultMessage: 'Uber Voucher',
  },
  landingIntroUberDes: {
    id: 'src.pages.Services.landingIntroUberDes',
    defaultMessage: `Make sure you are within an area that Uber services. You will be sent a voucher via text worth up to \${uberAmount} with a set expiry date. 
    You may use this voucher for ride sharing only.`,
  },
  landingIntroHeadsupBold: {
    id: 'src.pages.Services.landingIntroHeadsupBold',
    defaultMessage: 'Heads up! ',
  },
  landingIntroHeadsup: {
    id: 'src.pages.Services.landingIntroHeadsup',
    defaultMessage: 'A Claims expert will review your claim and determine coverage no matter which option you choose here.',
  },
  radioTitle: {
    id: 'src.pages.Services.radioTitle',
    defaultMessage: 'I’d like to proceed with:',
  },
  radioEnterprise: {
    id: 'src.pages.Services.radio.enterprise',
    defaultMessage: 'Enterprise car rental',
  },
  radioUber: {
    id: 'src.pages.Services.radio.uber',
    defaultMessage: 'Uber voucher',
  },
  ownRental: {
    id: 'src.pages.Services.radio.rental',
    defaultMessage: 'None, I’ve got a rental',
  },
  claimExpert: {
    id: 'src.pages.Services.radio.claim',
    defaultMessage: 'I’d like to speak with a Claims team member',
  },
  continueCta: {
    id: 'src.pages.Uber.continueCta',
    defaultMessage: 'Continue',
  },
  saveContinueCta: {
    id: 'src.pages.Uber.saveContinueCta',
    defaultMessage: 'Save & continue later',
  },
  error: {
    id: 'Oops! Looks like you forgot to fill this in.',
    defaultMessage: 'Oops! Looks like you forgot to fill this in.',
  },
});
